import './helpers/gt';

import './plugins/localeShared';

import { createApp, h } from 'vue';
import PortalVue from 'portal-vue';
import VueTippy from 'vue-tippy';
import { vMaska } from 'maska/vue';
import SharedApp from './SharedApp.vue';
import store from './store/sharedStore';
import vuetify from './plugins/vuetify';
import renderPublicPasswordPage from './views/publicUrl/renderPublicPasswordPage';

import svgSprite from '$$uiKitComp/VueIcon/svgSprite.vue';
import VgpAvatar from '$$uiKitComp/avatar/vgpAvatar.vue';
import vClickOutside from './plugins/directives/vClickOutside';
import vScroll from './plugins/directives/vScroll';

// Vue.config.devtools = true;
// Vue.config.productionTip = false;

/*
  Public url is separated Vue application
  Works because of webpack config aliases pointed to shared models
 */

const initVueApp = () => new Promise((resolve, reject) => {
  const vuePasswordContainer = document.querySelector('#shared-password-vue-container');
  const vueContainer = document.querySelector('#shared-vue-container');

  if (vuePasswordContainer) {
    renderPublicPasswordPage();
  } else if (vueContainer) {
    const viewType = vueContainer.getAttribute('data-view-type');
    const cdn = vueContainer.getAttribute('data-cdn');
    const token = vueContainer.getAttribute('data-token');
    const isTemplate = vueContainer.getAttribute('data-is-template');

    // We receive GT and other global variables from sharedApp.pug
    window.GT = {
      ...window.GT,
      cdn,
    };

    const app = createApp({
      components: {
        SharedApp,
      },
      data() {
        return {
          viewType,
          cdn,
          token,
          isTemplate,
        };
      },
      mounted() {
        resolve();
      },
      render() {
        return h(SharedApp, {
          viewType: this.viewType,
          isTemplate: this.isTemplate,
          token: this.token,
          cdn: this.cdn,
        });
      },
    });

    app.config.compilerOptions.whitespace = 'condense';

    app.component('SvgSprite', svgSprite);
    app.component('VgpAvatar', VgpAvatar);

    app.use(store);
    app.use(PortalVue);
    app.use(vuetify);
    app.use(VueTippy, {
      directive: 'tippy',
      arrow: true,
      popperOptions: {
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              boundary: 'window',
            },
          },
        ],
      },
      defaultProps: {
        placement: 'auto-end',
        allowHTML: true,
        appendTo: () => document.body,
        popperOptions: {
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                boundary: 'window',
              },
            },
          ],
        },
      },
    });

    app.directive('click-outside', vClickOutside);
    app.directive('scroll', vScroll);
    app.directive('maska', vMaska);

    app.mount('#shared-vue-container');
  }
});

initVueApp();

export {
  initVueApp,
};
